import { MarketEventTag } from '@/type/polymark';
import useSWR from 'swr';

export const supportCryptos = [
  'bitcoin',
  'ethereum',
  'solana',
  'xrp',
  'dogecoin',
  'bnb',
  'hyperliquid',
  // 'chainlink',
  // 'ethena',
];

export type CryptoType = (typeof supportCryptos)[number];

export const recurrences = [
  '5m',
  '15m',
  '1h',
  '4h',
  'daily',
  'weekly',
  'monthly',
  'yearly',
] as const;

export const crypto2Symbol: Record<CryptoType, string> = {
  bitcoin: 'BTC',
  ethereum: 'ETH',
  solana: 'SOL',
  xrp: 'XRP',
  dogecoin: 'DOGE',
  bnb: 'BNB',
  hyperliquid: 'HYPE',
} as const;

export type RecurrenceType = (typeof recurrences)[number];

export function isRecurring(tags: MarketEventTag[]) {
  return !!tags.find((t) => t.slug === 'recurring');
}

export function getRecurrence(tags: MarketEventTag[]): RecurrenceType {
  const tag = tags.find((t) => recurrences.includes(t.slug.toLowerCase() as RecurrenceType));
  return tag?.slug?.toLowerCase() as RecurrenceType;
}

export function getCryptoName(tags: MarketEventTag[]): CryptoType {
  const tag = tags.find((t) => supportCryptos.includes(t.slug.toLowerCase()));
  return tag?.slug?.toLowerCase() as CryptoType;
}

export function isRecurringCrypto(tags: MarketEventTag[]) {
  return isRecurring(tags) && !!getCryptoName(tags);
}

// 秒
export function generateFidelity(recurrence?: RecurrenceType) {
  switch (recurrence) {
    case '5m':
    case '15m':
      return '1s';
    case '1h':
    case '4h':
      return '60';
    case 'daily':
      return '300';
    case 'weekly':
    case 'monthly':
      return '3600';
    case 'yearly':
      return '86400';
    default:
      return '60';
  }
}

export function generateInterval(recurrence?: RecurrenceType) {
  switch (recurrence) {
    case '5m':
    case '15m':
    case '1h':
    case '4h':
    case 'daily':
    case 'weekly':
      return '1d';
    case 'monthly':
      return '1m';
    case 'yearly':
      return '12m';
    default:
      return '1m';
  }
}

function getPriceHistoryFromPoly() {}

function getPriceHistoryFromPredic() {}

export default function usePriceHistory() {}
